import {ref} from 'vue';
import {useRouter} from 'vue-router';
import useCountry from '@/composables/countryDependable';
import useApplicationCart from '@/composables/applicationCart/applicationCart';
import {useContactStore} from '@/store/contact';
declare let paypal: any;
import PaypalService from '@/core/paypal/paypal';
import {SUCCESS} from '@/router/route-name';
import useLoggable from '@/composables/loggable';

const usePaypal = () => {
    const loading = ref(false);
    const paypalService = ref<null|PaypalService>(null)

    const router = useRouter();
    const country = useCountry();
    const { submitApplication, paymentRef } = useApplicationCart();
    const {isContactFormValid} = useContactStore();
    const { info } = useLoggable();

    const loadPaypal = async () => {
        if (paypal && paypal.Buttons) {
            const getPaymentRef = () => {
                return paymentRef.value;
            }

            const onBeforeCreateOrder = async () => {
                if (!isContactFormValid()) {
                    return false;
                }
                loading.value = true;
                const response = await submitApplication();

                return response.success;
            }

            const onRouterChange = (transactionId: string) => {
                return router.push({name: SUCCESS, query: { paypal_id: transactionId }});
            }
            const onError = (err: string) => {
                loading.value = false;
                // todo should let user know the error but not only throw it
                throw new Error(err);
            }
            const onInfo = (msg: string) => {
                info(msg, {});
            }
            const onFinish = () => {
                loading.value = false;
            }
            const style = {
                layout: 'horizontal', // not show credit payment icon
                tagline: false, // not show span under icon
                color: 'blue',
                height: 36
            }

            const config = {
                getPaymentRef,
                onBeforeCreateOrder,
                onRouterChange,
                onError,
                onInfo,
                onFinish,
                style,
            }

            paypalService.value = PaypalService.initPaypal(paypal, country, config);
        }
    }

    const reloadPaypal = () => {
        if (!paypalService.value) {
            return;

        }
        paypalService.value.renderPayPalButton();
    }

    const interval = window.setInterval(() => {
        if (typeof paypal !== 'undefined') {
            loadPaypal();
            clearInterval(interval);
        }
    }, 500);

    return {
        loading,
        reloadPaypal
    }
}

export default usePaypal;